import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    sidebar: {
      bg: '#1A202C', // Arka plan rengi
      text: '#CBD5E0', // Metin rengi
      hoverBg: '#2D3748', // Hover arka plan rengi
      border: 'rgba(0, 0, 0, 0.1)', // Border rengi
    },
    brand: {
      primary: '#3182CE', // butonlar için birincil renk
    },
  },
});

export default theme;
